import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-embed-menu',
  templateUrl: './embed-menu.component.html',
  styleUrls: ['./embed-menu.component.scss'],
})
export class EmbedMenuComponent {}
